import Page from '@components/Page';
import AppContext from '@services/Context';
import I18n from '@src/i18n';
import { Modal } from 'antd';
import React from 'react';
import styled from 'styled-components';

const confirm = Modal.confirm;
export default class HomeNoPermission extends React.Component<any, any> {

  error(logout: any) {
    confirm({
      title: I18n.l('label.title.userNoPermission'),
      content: I18n.l('common.noPermission'),
      okText: (I18n.l('common.logout')).toUpperCase(),
      cancelText: (I18n.l('common.tradePillarOrUnit')).toUpperCase(),
      iconType: 'exclamation-circle',
      onOk() {
        logout();
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    return (
      <AppContext.Consumer>
        {({ Logout }) => (
          <Page>
            <Wrapper>
              <h1>{I18n.l('common.welcome')}</h1>
              {this.error(Logout)}
            </Wrapper>
          </Page>
        )}
      </AppContext.Consumer>
    );
  }
}

//#region CSS
const Wrapper = styled.div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
`;
//#endregion

